import { Component, OnDestroy, OnInit } from '@angular/core';
import { GenericDocContainerModel, Pagination, CashbookTxnLineService, CashbookContainerModel, CashbookService } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { from, forkJoin, iif, of, Subject, } from 'rxjs';
import { mergeMap, concatMap, map, tap, catchError, toArray, debounceTime } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { CashbookViewColumn1ViewModelActions } from '../../../generic-doc-view-model-controller/generic-doc-cashbook-view-model-controller/actions';
import { CashbookViewColumn1ViewSelectors } from '../../../generic-doc-view-model-controller/generic-doc-cashbook-view-model-controller/selectors';
import { CashbookViewColumnViewModelStates } from '../../../generic-doc-view-model-controller/generic-doc-cashbook-view-model-controller/states';
import { GridOptions } from 'ag-grid-enterprise';
import { SessionActions } from "../../../modules/session/session-controller/actions";
import { SessionSelectors } from '../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../modules/session/session-controller/states';
import { Store } from '@ngrx/store';
import { SharedUtilitiesHelperFunctions } from '../../helper-functions';

@Component({
  selector: 'app-cashbook-txn',
  templateUrl: './cashbook-txn.component.html',
  styleUrls: ['./cashbook-txn.component.css']
})
export class CashbookTxnComponent implements OnInit, OnDestroy {

  protected subs = new SubSink();
  private columnMoveSubject: Subject<void> = new Subject<void>();
  private debounceTimeMs = 500;
 

  cashbookMap: {guid: string, acc_no: string}[] = [];

  gridApi;
  gridColumnApi;
  rowData: [];
  gridOptions:GridOptions = {
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left' },
      ]
    },
    defaultColDef: {
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 100,
      flex: 1,
      sortable: true,
      resizable: true,
      //suppressCsvExport: true,
      floatingFilter: true
    },
    pagination: true
  }

  columnsDefs = [
    {
      headerName: 'Txn Date', field: 'bl_fi_cashbook_txn_line.date_txn_doc', cellStyle: () => ({ 'text-align': 'left' }),
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '',
    },
    { headerName: 'Accout No', field: 'bl_fi_cashbook_txn_line.acc_no', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Remarks', field: 'bl_fi_cashbook_txn_line.descr', cellStyle: () => ({ 'text-align': 'left' }) },
    {
      headerName: 'Amount', field: 'bl_fi_cashbook_txn_line.txn_amount', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
  ];

  constructor(
    public readonly viewModelStore: Store<CashbookViewColumnViewModelStates>,
    protected readonly sessionStore: Store<SessionStates>,
    protected cashbookTxnLineService :CashbookTxnLineService,
    protected cashbookService :CashbookService
  ) {}

  ngOnInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
  }

  createData(genericDoc: GenericDocContainerModel) {
    console.log("on create data....");

    const guids = [...new Set(
      genericDoc.bl_fi_generic_doc_line
        .map(line => line.guid))];

    const pagination = new Pagination();
    pagination.conditionalCriteria.push({
      columnName: 'guids_generic_doc_line',
      operator: '=',
      value: guids.toString()
    });

    pagination.conditionalCriteria.push({
      columnName: 'calcTotalRecords',
      operator: '=',
      value: 'false'
    });

    // pagination.sortCriteria.push(
    //   { columnName: 'orderBy', value: 'date_txn_doc' },
    //   { columnName: 'order', value: 'DESC' }
    // )

    this.subs.sink = this.cashbookTxnLineService.getByCriteria(pagination, AppConfig.apiVisa).pipe(
      mergeMap(a => from(a.data).pipe(
        concatMap(a_a => forkJoin([
            iif(() => !!this.cashbookMap.find(s => s.guid === a_a.bl_fi_cashbook_txn_line.guid_cashbook.toString()),
              of(this.cashbookMap.find(s => s.guid === a_a.bl_fi_cashbook_txn_line.guid_cashbook.toString())).pipe(
                map(a_a_a => {
                  const container = new CashbookContainerModel();
					        container.bl_fi_mst_cashbook_hdr.guid = a_a_a.guid;
					        container.bl_fi_mst_cashbook_hdr.acc_no = a_a_a.acc_no;
                  return container;
                })
              ),
              this.cashbookService.getByGuid(a_a.bl_fi_cashbook_txn_line.guid_cashbook.toString(), AppConfig.apiVisa).pipe(
                tap(a_a_b => this.cashbookMap.push(
                  {
                    guid: a_a_b.data.bl_fi_mst_cashbook_hdr.guid.toString(),
                    acc_no: (a_a_b.data.bl_fi_mst_cashbook_hdr.code ? a_a_b.data.bl_fi_mst_cashbook_hdr.acc_no.toString() : a_a_b.data.bl_fi_mst_cashbook_hdr.status.toString()),
                  })),
                map(a_a_c => a_a_c.data),
                catchError((err) => of(err))
              )
            )]
          ).pipe(
          map(([b_a]) => {
            Object.assign(a_a.bl_fi_cashbook_txn_line,
              {
                acc_no: b_a.error ? b_a.error.code : (b_a.bl_fi_mst_cashbook_hdr.code ? b_a.bl_fi_mst_cashbook_hdr.acc_no : b_a.bl_fi_mst_cashbook_hdr.status) ,
              });
            return a_a;
          })
          )
        ),
        toArray(),
        map(b => {
          a.data = b;
          return a;
        })
        )
      )
    ).subscribe(resp => {
      this.gridApi.setRowData(resp.data);
    }, err => {
      console.log(err);
    }); 
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  saveColumnStateToLocal(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.viewModelStore.dispatch(CashbookViewColumn1ViewModelActions.setGenericDocCashbookListing_State({genericDocCashbookListingState:serializedColumnState}))
  }
  ngAfterViewInit() {
    // Listen for column movement and debounce the action dispatch
    this.subs.add(
      this.columnMoveSubject
        .pipe(debounceTime(this.debounceTimeMs))
        .subscribe(() => {
          this.saveColumnStateToLocal(this.gridOptions.columnApi);
          this.saveColumnStateToBackend(this.gridOptions.columnApi);
        })
    );
    
    this.subs.sink = this.viewModelStore
      .select(CashbookViewColumn1ViewSelectors.selectGenericDocCashbookListing_State)
      .subscribe((data) => {
        if (!data) {
          this.subs.sink = this.sessionStore
            .select(SessionSelectors.selectPersonalSettings)
            .subscribe((data) => {
              if (data.genericDocCashbookListingState) {
                console.log("data",data.genericDocCashbookListingState);
                this.viewModelStore.dispatch(
                  CashbookViewColumn1ViewModelActions.setGenericDocCashbookListing_State({
                    genericDocCashbookListingState: data.genericDocCashbookListingState,
                  })
                );
              }
            });
        }
      });
    
    setTimeout(()=>{
      let serializedColumnState;
      this.subs.sink = this.viewModelStore.select(CashbookViewColumn1ViewSelectors.selectGenericDocCashbookListing_State).subscribe(data=>{
        if(data){
          serializedColumnState=data;
        }
      })
      if (serializedColumnState) {
        const newColumnState = JSON.parse(serializedColumnState);
        const currentColumnState = this.gridOptions.columnApi.getColumnState();
        const currentColumnIds = new Set(currentColumnState.map(column => column.colId));
      
        const hiddenColumns = {};
          currentColumnState.forEach(column => {
            if (column.hide) {
              hiddenColumns[column.colId] = true;
            }
          });
        const filteredNewColumnState = newColumnState.filter(column => currentColumnIds.has(column.colId));
        const combinedColumnState = filteredNewColumnState.map(column => {
            if (hiddenColumns[column.colId] !== undefined) {
              column.hide = hiddenColumns[column.colId];
            }
            return column;
          });
          this.gridOptions.columnApi.applyColumnState({
            state: combinedColumnState,
            applyOrder: true, // Set this to true to forcefully apply the state
          });
          console.log('Column State Applied:', combinedColumnState);
      }
    
    },2000);
    
   
    
  }
  
  // Define a function to save column state to the backend
  saveColumnStateToBackend(columnApi) {
    const columnState = columnApi.getColumnState();
    const serializedColumnState = JSON.stringify(columnState);
    this.sessionStore.dispatch(SessionActions.saveColumnStateInit({ settings: {genericDocCashbookListingState:serializedColumnState} }));
   }
  ngAfterViewChecked() {
    // Listen for column visibility changes
    this.gridOptions.api.addEventListener("columnVisible", (event) => {
      this.columnMoveSubject.next();
    });
    // Listen for column movement
    this.gridOptions.api.addEventListener("columnMoved", (event) => {
      this.columnMoveSubject.next();
    });
  }

}
